export { default } from './RefundGuidePage';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundGuidePage/index.ts